<template>
  <div class="adminMain">


    <div class="control">
      <div class="box">
        <img :src="`/imgs/LOGO.png`" alt="Logo" />
        <h2>BODA 관리자</h2>
      </div>
      <div class="profile">
        <h2>안녕하세요<br>{{ member_info.name }} {{ member_info.level }} 관리자님</h2>
        <span>로그아웃</span>
      </div>
      <ul class="menu" v-for="menu in menus" :key="menu.name">
        <li @click="selectMenu(menu)" :class="{ active: menu.show }">{{menu.name}}</li>
      </ul>
    </div>


    <div class="content">
      <template v-for="menu in menus" :key="menu.name">
        <component :is="menu.component" v-if="menu.show"></component>
      </template>
    </div>


    </div>
</template>




<script>
import { inject, ref, nextTick } from "vue";

import coverageAnalysisSetting from "@/components/admin-fragment/coverageAnalysisSetting.vue";
import adminHome from "@/components/admin-fragment/adminHome.vue";
import boardAdmin from "@/components/admin-fragment/boardAdmin.vue";
import insuCompanyAdmin from "@/components/admin-fragment/insuCompanyAdmin.vue";
import adminCounsel from "@/components/admin-fragment/adminCounsel.vue";
import adminCAbenefitEx from "@/components/admin-fragment/adminCAbenefitEx.vue";
import adminTutorial  from "@/components/admin-fragment/adminTutorial.vue";
import adminBugReport from "@/components/admin-fragment/adminBugReport.vue";
import adminMember from "@/components/admin-fragment/adminMember.vue";
import adminGiftHistory from "@/components/admin-fragment/adminGiftHistory.vue";

export default {
  name: "AdminMain",
  components: {
    coverageAnalysisSetting,
    adminHome,
    boardAdmin,
    insuCompanyAdmin,
    adminCounsel,
    adminCAbenefitEx,
    adminTutorial,
    adminBugReport,
    adminMember,
    adminGiftHistory
  },
  setup() {

    const menus = ref([
      { name:"홈", component:adminHome, show:true },
      { name:"회원 관리", component:adminMember, show:false },
      { name:"보장분석 설정", component:coverageAnalysisSetting, show:false },
      { name:"보상예시 관리", component:adminCAbenefitEx, show:false },
      { name:"게시판 관리자", component:boardAdmin, show:false },
      { name:"보험원사 정보관리", component:insuCompanyAdmin, show:false },
      { name:"상담 관리", component:adminCounsel, show:false },
      { name:"튜토리얼관리", component:adminTutorial, show:false },
      { name:"버그 리포트", component:adminBugReport, show:false },
      { name:"선물 수령 내역", component:adminGiftHistory, show:false },
    ]);
    
    const member_info = inject("member_info");

    nextTick(() => {
      if (!member_info || member_info.level >= 1) {
        console.error("member_info is not provided");
        window.location.href = "/";
        return;
      }
    });

    function selectMenu(menu) {
      menus.value.forEach(m => m.show = false);
      const selectedMenu = menus.value.find(m => m.name === menu.name);
      if (selectedMenu) {
        selectedMenu.show = true;
      }
    }

    return {
      member_info,
      menus,
      selectMenu,
    };
  }
};
</script>






<style scoped>

.adminMain {
  width: 100%;
  height: 100vh;
  display:flex;
  flex-direction: row;
  background-color: var(--color-background);
}

.control {
  width: 240px;
  height: 100%;
  background-color: var(--color-background-light);
  padding: 16px;
  box-sizing: border-box;
  display:flex;
  flex-direction: column;
  gap:24px;
}

.control.fold {
  width: 160px;
  overflow: hidden;
}

.control > ul {
  width: 100%;
  height: fit-content;
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  border-top:1px solid var(--color-text-secondary);
}

.control > ul > li {
  width: 100%;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  cursor: pointer;
  color: var(--color-text-primary);
  border-bottom:1px solid var(--color-text-secondary);
}

.control > ul > li:hover,
.control > ul > li.active {
  background-color: var(--color-surface-reverse);
}

.control > .profile {
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  gap:6px;
}

.control > .profile > h2 {
  margin: 0px;
  color: var(--color-text-primary);
  font-size: 16px;
}

.control > .profile > span {
  width: 100%;
  height: fit-content;
  color: var(--color-text-primary);
  font-size: 14px;
  cursor: pointer;
  text-decoration:underline;
}

.control > .box {
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap:12px;
}

.control > .box > img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}

.control > .box > h2 {
  margin: 0px;
  color: var(--color-text-primary);
  font-size: 16px;
  text-align: center;
}

.content {
  width: 100%;
  flex:1;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
}


</style>